/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2021-2024 Open Assessment Technologies SA;
 */
import { __ } from '@oat-sa-private/ui-core';

export function getTranslationMapping() {
    // We want these __() calls to be evaluated as late as possible,
    // otherwise the object values will be set on module import.
    return {
        'Increase indent': __('Increase indent'),
        'Decrease indent': __('Decrease indent'),
        'Align left': __('Align left'),
        'Align right': __('Align right'),
        'Align center': __('Align center'),
        Justify: __('Justify'),
        'Text alignment': __('Text alignment'),
        'Text alignment toolbar': __('Text alignment toolbar'),
        'Widget toolbar': __('Widget toolbar'),
        'Insert paragraph before block': __('Insert paragraph before block'),
        'Insert paragraph after block': __('Insert paragraph after block'),
        'Font Size': __('Font Size'),
        Tiny: __('Tiny'),
        Small: __('Small'),
        Big: __('Big'),
        Huge: __('Huge'),
        'Font Family': __('Font Family'),
        Default: __('Default'),
        'Font Color': __('Font Color'),
        'Font Background Color': __('Font Background Color'),
        'Document colors': __('Document colors'),
        Bold: __('Bold'),
        Italic: __('Italic'),
        Underline: __('Underline'),
        Code: __('Code'),
        Strikethrough: __('Strikethrough'),
        Subscript: __('Subscript'),
        Superscript: __('Superscript'),
        'Words: %0': __('Words: %d'),
        'Characters: %0': __('Characters: %d'),
        'Special characters': __('Special characters'),
        'leftwards double arrow': __('leftwards double arrow'),
        'rightwards double arrow': __('rightwards double arrow'),
        'upwards double arrow': __('upwards double arrow'),
        'downwards double arrow': __('downwards double arrow'),
        'leftwards dashed arrow': __('leftwards dashed arrow'),
        'rightwards dashed arrow': __('rightwards dashed arrow'),
        'upwards dashed arrow': __('upwards dashed arrow'),
        'downwards dashed arrow': __('downwards dashed arrow'),
        'leftwards arrow to bar': __('leftwards arrow to bar'),
        'rightwards arrow to bar': __('rightwards arrow to bar'),
        'upwards arrow to bar': __('upwards arrow to bar'),
        'downwards arrow to bar': __('downwards arrow to bar'),
        'up down arrow with base': __('up down arrow with base'),
        'back with leftwards arrow above': __('back with leftwards arrow above'),
        'end with leftwards arrow above': __('end with leftwards arrow above'),
        'on with exclamation mark with left right arrow above': __(
            'on with exclamation mark with left right arrow above'
        ),
        'soon with rightwards arrow above': __('soon with rightwards arrow above'),
        'top with upwards arrow above': __('top with upwards arrow above'),
        'Dollar sign': __('Dollar sign'),
        'Euro sign': __('Euro sign'),
        'Yen sign': __('Yen sign'),
        'Pound sign': __('Pound sign'),
        'Cent sign': __('Cent sign'),
        'Euro-currency sign': __('Euro-currency sign'),
        'Colon sign': __('Colon sign'),
        'Cruzeiro sign': __('Cruzeiro sign'),
        'French franc sign': __('French franc sign'),
        'Lira sign': __('Lira sign'),
        'Currency sign': __('Currency sign'),
        'Bitcoin sign': __('Bitcoin sign'),
        'Mill sign': __('Mill sign'),
        'Naira sign': __('Naira sign'),
        'Peseta sign': __('Peseta sign'),
        'Rupee sign': __('Rupee sign'),
        'Won sign': __('Won sign'),
        'New sheqel sign': __('New sheqel sign'),
        'Dong sign': __('Dong sign'),
        'Kip sign': __('Kip sign'),
        'Tugrik sign': __('Tugrik sign'),
        'Drachma sign': __('Drachma sign'),
        'German penny sign': __('German penny sign'),
        'Peso sign': __('Peso sign'),
        'Guarani sign': __('Guarani sign'),
        'Austral sign': __('Austral sign'),
        'Hryvnia sign': __('Hryvnia sign'),
        'Cedi sign': __('Cedi sign'),
        'Livre tournois sign': __('Livre tournois sign'),
        'Spesmilo sign': __('Spesmilo sign'),
        'Tenge sign': __('Tenge sign'),
        'Indian rupee sign': __('Indian rupee sign'),
        'Turkish lira sign': __('Turkish lira sign'),
        'Nordic mark sign': __('Nordic mark sign'),
        'Manat sign': __('Manat sign'),
        'Ruble sign': __('Ruble sign'),
        'Latin capital letter a with macron': __('Latin capital letter a with macron'),
        'Latin small letter a with macron': __('Latin small letter a with macron'),
        'Latin capital letter a with breve': __('Latin capital letter a with breve'),
        'Latin small letter a with breve': __('Latin small letter a with breve'),
        'Latin capital letter a with ogonek': __('Latin capital letter a with ogonek'),
        'Latin small letter a with ogonek': __('Latin small letter a with ogonek'),
        'Latin capital letter c with acute': __('Latin capital letter c with acute'),
        'Latin small letter c with acute': __('Latin small letter c with acute'),
        'Latin capital letter c with circumflex': __('Latin capital letter c with circumflex'),
        'Latin small letter c with circumflex': __('Latin small letter c with circumflex'),
        'Latin capital letter c with dot above': __('Latin capital letter c with dot above'),
        'Latin small letter c with dot above': __('Latin small letter c with dot above'),
        'Latin capital letter c with caron': __('Latin capital letter c with caron'),
        'Latin small letter c with caron': __('Latin small letter c with caron'),
        'Latin capital letter d with caron': __('Latin capital letter d with caron'),
        'Latin small letter d with caron': __('Latin small letter d with caron'),
        'Latin capital letter d with stroke': __('Latin capital letter d with stroke'),
        'Latin small letter d with stroke': __('Latin small letter d with stroke'),
        'Latin capital letter e with macron': __('Latin capital letter e with macron'),
        'Latin small letter e with macron': __('Latin small letter e with macron'),
        'Latin capital letter e with breve': __('Latin capital letter e with breve'),
        'Latin small letter e with breve': __('Latin small letter e with breve'),
        'Latin capital letter e with dot above': __('Latin capital letter e with dot above'),
        'Latin small letter e with dot above': __('Latin small letter e with dot above'),
        'Latin capital letter e with ogonek': __('Latin capital letter e with ogonek'),
        'Latin small letter e with ogonek': __('Latin small letter e with ogonek'),
        'Latin capital letter e with caron': __('Latin capital letter e with caron'),
        'Latin small letter e with caron': __('Latin small letter e with caron'),
        'Latin capital letter g with circumflex': __('Latin capital letter g with circumflex'),
        'Latin small letter g with circumflex': __('Latin small letter g with circumflex'),
        'Latin capital letter g with breve': __('Latin capital letter g with breve'),
        'Latin small letter g with breve': __('Latin small letter g with breve'),
        'Latin capital letter g with dot above': __('Latin capital letter g with dot above'),
        'Latin small letter g with dot above': __('Latin small letter g with dot above'),
        'Latin capital letter g with cedilla': __('Latin capital letter g with cedilla'),
        'Latin small letter g with cedilla': __('Latin small letter g with cedilla'),
        'Latin capital letter h with circumflex': __('Latin capital letter h with circumflex'),
        'Latin small letter h with circumflex': __('Latin small letter h with circumflex'),
        'Latin capital letter h with stroke': __('Latin capital letter h with stroke'),
        'Latin small letter h with stroke': __('Latin small letter h with stroke'),
        'Latin capital letter i with tilde': __('Latin capital letter i with tilde'),
        'Latin small letter i with tilde': __('Latin small letter i with tilde'),
        'Latin capital letter i with macron': __('Latin capital letter i with macron'),
        'Latin small letter i with macron': __('Latin small letter i with macron'),
        'Latin capital letter i with breve': __('Latin capital letter i with breve'),
        'Latin small letter i with breve': __('Latin small letter i with breve'),
        'Latin capital letter i with ogonek': __('Latin capital letter i with ogonek'),
        'Latin small letter i with ogonek': __('Latin small letter i with ogonek'),
        'Latin capital letter i with dot above': __('Latin capital letter i with dot above'),
        'Latin small letter dotless i': __('Latin small letter dotless i'),
        'Latin capital ligature ij': __('Latin capital ligature ij'),
        'Latin small ligature ij': __('Latin small ligature ij'),
        'Latin capital letter j with circumflex': __('Latin capital letter j with circumflex'),
        'Latin small letter j with circumflex': __('Latin small letter j with circumflex'),
        'Latin capital letter k with cedilla': __('Latin capital letter k with cedilla'),
        'Latin small letter k with cedilla': __('Latin small letter k with cedilla'),
        'Latin small letter kra': __('Latin small letter kra'),
        'Latin capital letter l with acute': __('Latin capital letter l with acute'),
        'Latin small letter l with acute': __('Latin small letter l with acute'),
        'Latin capital letter l with cedilla': __('Latin capital letter l with cedilla'),
        'Latin small letter l with cedilla': __('Latin small letter l with cedilla'),
        'Latin capital letter l with caron': __('Latin capital letter l with caron'),
        'Latin small letter l with caron': __('Latin small letter l with caron'),
        'Latin capital letter l with middle dot': __('Latin capital letter l with middle dot'),
        'Latin small letter l with middle dot': __('Latin small letter l with middle dot'),
        'Latin capital letter l with stroke': __('Latin capital letter l with stroke'),
        'Latin small letter l with stroke': __('Latin small letter l with stroke'),
        'Latin capital letter n with acute': __('Latin capital letter n with acute'),
        'Latin small letter n with acute': __('Latin small letter n with acute'),
        'Latin capital letter n with cedilla': __('Latin capital letter n with cedilla'),
        'Latin small letter n with cedilla': __('Latin small letter n with cedilla'),
        'Latin capital letter n with caron': __('Latin capital letter n with caron'),
        'Latin small letter n with caron': __('Latin small letter n with caron'),
        'Latin small letter n preceded by apostrophe': __('Latin small letter n preceded by apostrophe'),
        'Latin capital letter eng': __('Latin capital letter eng'),
        'Latin small letter eng': __('Latin small letter eng'),
        'Latin capital letter o with macron': __('Latin capital letter o with macron'),
        'Latin small letter o with macron': __('Latin small letter o with macron'),
        'Latin capital letter o with breve': __('Latin capital letter o with breve'),
        'Latin small letter o with breve': __('Latin small letter o with breve'),
        'Latin capital letter o with double acute': __('Latin capital letter o with double acute'),
        'Latin small letter o with double acute': __('Latin small letter o with double acute'),
        'Latin capital ligature oe': __('Latin capital ligature oe'),
        'Latin small ligature oe': __('Latin small ligature oe'),
        'Latin capital letter r with acute': __('Latin capital letter r with acute'),
        'Latin small letter r with acute': __('Latin small letter r with acute'),
        'Latin capital letter r with cedilla': __('Latin capital letter r with cedilla'),
        'Latin small letter r with cedilla': __('Latin small letter r with cedilla'),
        'Latin capital letter r with caron': __('Latin capital letter r with caron'),
        'Latin small letter r with caron': __('Latin small letter r with caron'),
        'Latin capital letter s with acute': __('Latin capital letter s with acute'),
        'Latin small letter s with acute': __('Latin small letter s with acute'),
        'Latin capital letter s with circumflex': __('Latin capital letter s with circumflex'),
        'Latin small letter s with circumflex': __('Latin small letter s with circumflex'),
        'Latin capital letter s with cedilla': __('Latin capital letter s with cedilla'),
        'Latin small letter s with cedilla': __('Latin small letter s with cedilla'),
        'Latin capital letter s with caron': __('Latin capital letter s with caron'),
        'Latin small letter s with caron': __('Latin small letter s with caron'),
        'Latin capital letter t with cedilla': __('Latin capital letter t with cedilla'),
        'Latin small letter t with cedilla': __('Latin small letter t with cedilla'),
        'Latin capital letter t with caron': __('Latin capital letter t with caron'),
        'Latin small letter t with caron': __('Latin small letter t with caron'),
        'Latin capital letter t with stroke': __('Latin capital letter t with stroke'),
        'Latin small letter t with stroke': __('Latin small letter t with stroke'),
        'Latin capital letter u with tilde': __('Latin capital letter u with tilde'),
        'Latin small letter u with tilde': __('Latin small letter u with tilde'),
        'Latin capital letter u with macron': __('Latin capital letter u with macron'),
        'Latin small letter u with macron': __('Latin small letter u with macron'),
        'Latin capital letter u with breve': __('Latin capital letter u with breve'),
        'Latin small letter u with breve': __('Latin small letter u with breve'),
        'Latin capital letter u with ring above': __('Latin capital letter u with ring above'),
        'Latin small letter u with ring above': __('Latin small letter u with ring above'),
        'Latin capital letter u with double acute': __('Latin capital letter u with double acute'),
        'Latin small letter u with double acute': __('Latin small letter u with double acute'),
        'Latin capital letter u with ogonek': __('Latin capital letter u with ogonek'),
        'Latin small letter u with ogonek': __('Latin small letter u with ogonek'),
        'Latin capital letter w with circumflex': __('Latin capital letter w with circumflex'),
        'Latin small letter w with circumflex': __('Latin small letter w with circumflex'),
        'Latin capital letter y with circumflex': __('Latin capital letter y with circumflex'),
        'Latin small letter y with circumflex': __('Latin small letter y with circumflex'),
        'Latin capital letter y with diaeresis': __('Latin capital letter y with diaeresis'),
        'Latin capital letter z with acute': __('Latin capital letter z with acute'),
        'Latin small letter z with acute': __('Latin small letter z with acute'),
        'Latin capital letter z with dot above': __('Latin capital letter z with dot above'),
        'Latin small letter z with dot above': __('Latin small letter z with dot above'),
        'Latin capital letter z with caron': __('Latin capital letter z with caron'),
        'Latin small letter z with caron': __('Latin small letter z with caron'),
        'Latin small letter long s': __('Latin small letter long s'),
        'Latin small letter a with acute': __('Latin small letter a with acute'),
        'Latin small letter e with acute': __('Latin small letter e with acute'),
        'Latin small letter i with acute': __('Latin small letter i with acute'),
        'Latin small letter o with acute': __('Latin small letter o with acute'),
        'Latin small letter u with acute': __('Latin small letter u with acute'),
        'Latin small letter n with tilde': __('Latin small letter n with tilde'),
        'Latin small letter u with diaeresis': __('Latin small letter u with diaeresis'),
        'Latin small letter c with cedilla': __('Latin small letter c with cedilla'),
        'Latin capital letter A with acute': __('Latin capital letter A with acute'),
        'Latin capital letter E with acute': __('Latin capital letter E with acute'),
        'Latin capital letter I with acute': __('Latin capital letter I with acute'),
        'Latin capital letter O with acute': __('Latin capital letter O with acute'),
        'Latin capital letter U with acute': __('Latin capital letter U with acute'),
        'Latin capital letter N with tilde': __('Latin capital letter N with tilde'),
        'Latin capital letter U with diaeresis': __('Latin capital letter U with diaeresis'),
        'Latin capital letter C with cedilla': __('Latin capital letter C with cedilla'),
        'Less-than sign': __('Less-than sign'),
        'Greater-than sign': __('Greater-than sign'),
        'Less-than or equal to': __('Less-than or equal to'),
        'Greater-than or equal to': __('Greater-than or equal to'),
        'En dash': __('En dash'),
        'Em dash': __('Em dash'),
        Macron: __('Macron'),
        Overline: __('Overline'),
        'Degree sign': __('Degree sign'),
        'Minus sign': __('Minus sign'),
        'Plus-minus sign': __('Plus-minus sign'),
        'Division sign': __('Division sign'),
        'Fraction slash': __('Fraction slash'),
        'Multiplication sign': __('Multiplication sign'),
        'Latin small letter f with hook': __('Latin small letter f with hook'),
        Integral: __('Integral'),
        'N-ary summation': __('N-ary summation'),
        Infinity: __('Infinity'),
        'Square root': __('Square root'),
        'Tilde operator': __('Tilde operator'),
        'Approximately equal to': __('Approximately equal to'),
        'Almost equal to': __('Almost equal to'),
        'Not equal to': __('Not equal to'),
        'Identical to': __('Identical to'),
        'Element of': __('Element of'),
        'Not an element of': __('Not an element of'),
        'Contains as member': __('Contains as member'),
        'N-ary product': __('N-ary product'),
        'Logical and': __('Logical and'),
        'Logical or': __('Logical or'),
        'Not sign': __('Not sign'),
        Intersection: __('Intersection'),
        Union: __('Union'),
        'Partial differential': __('Partial differential'),
        'For all': __('For all'),
        'There exists': __('There exists'),
        'Empty set': __('Empty set'),
        Nabla: __('Nabla'),
        'Asterisk operator': __('Asterisk operator'),
        'Proportional to': __('Proportional to'),
        Angle: __('Angle'),
        'Vulgar fraction one quarter': __('Vulgar fraction one quarter'),
        'Vulgar fraction one half': __('Vulgar fraction one half'),
        'Vulgar fraction three quarters': __('Vulgar fraction three quarters'),
        'Single left-pointing angle quotation mark': __('Single left-pointing angle quotation mark'),
        'Single right-pointing angle quotation mark': __('Single right-pointing angle quotation mark'),
        'Left-pointing double angle quotation mark': __('Left-pointing double angle quotation mark'),
        'Right-pointing double angle quotation mark': __('Right-pointing double angle quotation mark'),
        'Left single quotation mark': __('Left single quotation mark'),
        'Right single quotation mark': __('Right single quotation mark'),
        'Left double quotation mark': __('Left double quotation mark'),
        'Right double quotation mark': __('Right double quotation mark'),
        'Single low-9 quotation mark': __('Single low-9 quotation mark'),
        'Double low-9 quotation mark': __('Double low-9 quotation mark'),
        'Inverted exclamation mark': __('Inverted exclamation mark'),
        'Inverted question mark': __('Inverted question mark'),
        'Two dot leader': __('Two dot leader'),
        'Horizontal ellipsis': __('Horizontal ellipsis'),
        'Double dagger': __('Double dagger'),
        'Per mille sign': __('Per mille sign'),
        'Per ten thousand sign': __('Per ten thousand sign'),
        'Double exclamation mark': __('Double exclamation mark'),
        'Question exclamation mark': __('Question exclamation mark'),
        'Exclamation question mark': __('Exclamation question mark'),
        'Double question mark': __('Double question mark'),
        'Copyright sign': __('Copyright sign'),
        'Registered sign': __('Registered sign'),
        'Trade mark sign': __('Trade mark sign'),
        'Section sign': __('Section sign'),
        'Paragraph sign': __('Paragraph sign'),
        'Reversed paragraph sign': __('Reversed paragraph sign'),
        'Character categories': __('Character categories'),
        'Numbered List': __('Numbered List'),
        'Bulleted List': __('Bulleted List'),
        'To-do List': __('To-do List'),
        'Bulleted list styles toolbar': __('Bulleted list styles toolbar'),
        'Numbered list styles toolbar': __('Numbered list styles toolbar'),
        'Toggle the disc list style': __('Toggle the disc list style'),
        'Toggle the circle list style': __('Toggle the circle list style'),
        'Toggle the square list style': __('Toggle the square list style'),
        'Toggle the decimal list style': __('Toggle the decimal list style'),
        'Toggle the decimal with leading zero list style': __('Toggle the decimal with leading zero list style'),
        'Toggle the lower–roman list style': __('Toggle the lower–roman list style'),
        'Toggle the upper–roman list style': __('Toggle the upper–roman list style'),
        'Toggle the lower–latin list style': __('Toggle the lower–latin list style'),
        'Toggle the upper–latin list style': __('Toggle the upper–latin list style'),
        Disc: __('Disc'),
        Circle: __('Circle'),
        Square: __('Square'),
        Decimal: __('Decimal'),
        'Decimal with leading zero': __('Decimal with leading zero'),
        'Lower–roman': __('Lower–roman'),
        'Upper-roman': __('Upper-roman'),
        'Lower-latin': __('Lower-latin'),
        'Upper-latin': __('Upper-latin'),
        'Rich Text Editor, %0': __('Rich Text Editor, %s'),
        'Rich Text Editor': __('Rich Text Editor'),
        'Edit block': __('Edit block'),
        Next: __('Next'),
        Previous: __('Previous'),
        '%0 of %1': __('%d of %d'),
        'Editor toolbar': __('Editor toolbar'),
        'Dropdown toolbar': __('Dropdown toolbar'),
        'Show more items': __('Show more items'),
        Black: __('Black'),
        'Dim grey': __('Dim grey'),
        Grey: __('Grey'),
        'Light grey': __('Light grey'),
        White: __('White'),
        Red: __('Red'),
        Orange: __('Orange'),
        Yellow: __('Yellow'),
        'Light green': __('Light green'),
        Green: __('Green'),
        Aquamarine: __('Aquamarine'),
        Turquoise: __('Turquoise'),
        'Light blue': __('Light blue'),
        Blue: __('Blue'),
        Purple: __('Purple'),
        Undo: __('Undo'),
        Redo: __('Redo'),
        'Select all': __('Select all'),
        'Block quote': __('Block quote'),
        Save: __('Save'),
        Cancel: __('Cancel'),
        'Remove color': __('Remove color'),
        Paragraph: __('Paragraph'),
        Heading: __('Heading'),
        'Choose heading': __('Choose heading'),
        'Heading 1': __('Heading 1'),
        'Heading 2': __('Heading 2'),
        'Heading 3': __('Heading 3'),
        'Heading 4': __('Heading 4'),
        'Heading 5': __('Heading 5'),
        'Heading 6': __('Heading 6'),
        'Type your title': __('Type your title'),
        'Type or paste your content here.': __('Type or paste your content here.'),
        'Insert table': __('Insert table'),
        'Header column': __('Header column'),
        'Insert column left': __('Insert column left'),
        'Insert column right': __('Insert column right'),
        'Delete column': __('Delete column'),
        'Select column': __('Select column'),
        Column: __('Column'),
        'Header row': __('Header row'),
        'Insert row below': __('Insert row below'),
        'Insert row above': __('Insert row above'),
        'Delete row': __('Delete row'),
        'Select row': __('Select row'),
        Row: __('Row'),
        'Merge cell up': __('Merge cell up'),
        'Merge cell right': __('Merge cell right'),
        'Merge cell down': __('Merge cell down'),
        'Merge cell left': __('Merge cell left'),
        'Split cell vertically': __('Split cell vertically'),
        'Split cell horizontally': __('Split cell horizontally'),
        'Merge cells': __('Merge cells'),
        'Table toolbar': __('Table toolbar'),
        'Table properties': __('Table properties'),
        'Cell properties': __('Cell properties'),
        Border: __('Border'),
        Style: __('Style'),
        Width: __('Width'),
        Height: __('Height'),
        Color: __('Color'),
        Background: __('Background'),
        Padding: __('Padding'),
        Dimensions: __('Dimensions'),
        'Table cell text alignment': __('Table cell text alignment'),
        Alignment: __('Alignment'),
        'Horizontal text alignment toolbar': __('Horizontal text alignment toolbar'),
        'Vertical text alignment toolbar': __('Vertical text alignment toolbar'),
        'Table alignment toolbar': __('Table alignment toolbar'),
        None: __('None'),
        Solid: __('Solid'),
        Dotted: __('Dotted'),
        Dashed: __('Dashed'),
        Double: __('Double'),
        Groove: __('Groove'),
        Ridge: __('Ridge'),
        Inset: __('Inset'),
        Outset: __('Outset'),
        'Align cell text to the left': __('Align cell text to the left'),
        'Align cell text to the center': __('Align cell text to the center'),
        'Align cell text to the right': __('Align cell text to the right'),
        'Justify cell text': __('Justify cell text'),
        'Align cell text to the top': __('Align cell text to the top'),
        'Align cell text to the middle': __('Align cell text to the middle'),
        'Align cell text to the bottom': __('Align cell text to the bottom'),
        'Align table to the left': __('Align table to the left'),
        'Center table': __('Center table'),
        'Align table to the right': __('Align table to the right'),
        'The color is invalid. Try "#FF0000" or "rgb(255,0,0)" or "red".': __(
            'The color is invalid. Try "#FF0000" or "rgb(255,0,0)" or "red".'
        ),
        'The value is invalid. Try "10px" or "2em" or simply "2".': __(
            'The value is invalid. Try "10px" or "2em" or simply "2".'
        ),
        'Color picker': __('Color picker'),
        'Insert image': __('Insert image'),
        Original: __('Original'),
        'Resize image': __('Resize image'),
        'Left aligned image': __('Left aligned image'),
        'Right aligned image': __('Right aligned image'),
        'In line': __('In line'),
        'Centered image': __('Centered image'),
        'Break text': __('Break text'),
        'Wrap text': __('Wrap text'),
        'Upload image from computer': __('Upload image from computer'),
        Close: __('Close'),
        Category: __('Category'),
        All: __('All'),
        "Accessibility": __("Accessibility"),
        "Accessibility help": __("Accessibility help"),
        "Press %0 for help.": __("Press %0 for help."),
        'Below, you can find a list of keyboard shortcuts that can be used in the editor.': __(
            'Below, you can find a list of keyboard shortcuts that can be used in the editor.'
        ),
        'Content editing keystrokes': __('Content editing keystrokes'),
        'These keyboard shortcuts allow for quick access to content editing features.': __(
            'These keyboard shortcuts allow for quick access to content editing features.'
        ),
        'Bold text': __('Bold text'),
        'Copy selected content': __('Copy selected content'),
        'Insert a hard break (a new paragraph)': __('Insert a hard break (a new paragraph)'),
        'Insert a soft break (a <code>&lt;br&gt;</code> element)': __('Insert a soft break (a br element)'),
        'Italic text': __('Italic text'),
        'Paste content': __('Paste content'),
        'Paste content as plain text': __('Paste content as plain text'),
        'Strikethrough text': __('Strikethrough text'),
        'Underline text': __('Underline text'),
        'Keystrokes that can be used when a widget is selected (for example: image, table, etc.)': __(
            'Keystrokes that can be used when a widget is selected (for example: image, table, etc.)'
        ),
        'Insert a new paragraph directly after a widget': __('Insert a new paragraph directly after a widget'),
        'Insert a new paragraph directly before a widget': __('Insert a new paragraph directly before a widget'),
        'Move focus from an editable area back to the parent widget': __(
            'Move focus from an editable area back to the parent widget'
        ),
        'Move the caret to allow typing directly after a widget': __(
            'Move the caret to allow typing directly after a widget'
        ),
        'Move the caret to allow typing directly before a widget': __(
            'Move the caret to allow typing directly before a widget'
        ),
        'Keystrokes that can be used in a list': __('Keystrokes that can be used in a list'),
        'Decrease list item indent': __('Decrease list item indent'),
        'Increase list item indent': __('Increase list item indent'),
        'Keystrokes that can be used in a table cell': __('Keystrokes that can be used in a table cell'),
        'Insert a new table row (when in the last cell of a table)': __(
            'Insert a new table row (when in the last cell of a table)'
        ),
        'Move the selection to the next cell': __('Move the selection to the next cell'),
        'Move the selection to the previous cell': __('Move the selection to the previous cell'),
        'Navigate through the table': __('Navigate through the table'),
        'User interface and content navigation keystrokes': __('User interface and content navigation keystrokes'),
        'Use the following keystrokes for more efficient navigation in the CKEditor 5 user interface.': __(
            'Use the following keystrokes for more efficient navigation in the CKEditor 5 user interface.'
        ),
        'Close contextual balloons, dropdowns, and dialogs': __('Close contextual balloons, dropdowns, and dialogs'),
        'Execute the currently focused button. Executing buttons that interact with the editor content moves the focus back to the content.':
            __(
                'Execute the currently focused button. Executing buttons that interact with the editor content moves the focus back to the content.'
            ),
        'Move focus between form fields (inputs, buttons, etc.)': __(
            'Move focus between form fields (inputs, buttons, etc.)'
        ),
        'Move focus in and out of an active dialog window': __('Move focus in and out of an active dialog window'),
        'Move focus to the toolbar, navigate between toolbars': __(
            'Move focus to the toolbar, navigate between toolbars'
        ),
        'Navigate through the toolbar or menu bar': __('Navigate through the toolbar or menu bar'),
        'Open the accessibility help dialog': __('Open the accessibility help dialog'),
        "(may require <kbd>Fn</kbd>)": __("(may require <kbd>Fn</kbd>)")
    };
}
